import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="landing-footer"
      className="relative overflow-hidden border-t border-white/10 bg-[#0B1120]/40 pt-20"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="flex flex-col gap-10 pb-16 md:flex-row md:items-start md:justify-between">
          <div className="flex max-w-sm flex-col gap-4">
            <div className="flex items-center gap-3">
              <img
                src="https://customer-assets-lxgj4vgw.emergentagent.net/job_myfire-battles/artifacts/41aefba8a1ad4cfb_pinza_logo_1.webp"
                alt="La Pinza"
                className="h-8 w-8 object-contain"
              />
              <span className="font-heading text-lg font-black tracking-tighter text-white">
                LA PINZA
              </span>
            </div>
            <p className="font-body text-sm leading-relaxed text-[#94A3B8]">
              La plataforma que le da transparencia, dinamismo y tecnología a las
              batallas de gallos.
            </p>
          </div>

          <div className="flex gap-16">
            <div className="flex flex-col gap-3">
              <span className="font-ui text-[10px] font-bold uppercase tracking-[0.25em] text-[#64748B]">
                Navegación
              </span>
              <a href="#como-funciona" className="font-ui text-sm text-[#94A3B8] transition-colors duration-200 hover:text-[#FF5500]">
                Cómo funciona
              </a>
              <a href="#caracteristicas" className="font-ui text-sm text-[#94A3B8] transition-colors duration-200 hover:text-[#FF5500]">
                Características
              </a>
              <Link to="/eventos" className="font-ui text-sm text-[#94A3B8] transition-colors duration-200 hover:text-[#FF5500]">
                Eventos en vivo
              </Link>
            </div>
            <div className="flex flex-col gap-3">
              <span className="font-ui text-[10px] font-bold uppercase tracking-[0.25em] text-[#64748B]">
                Síguenos
              </span>
              <a
                href="https://instagram.com/lapinza.app"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="inline-flex items-center gap-2 font-ui text-sm text-[#94A3B8] transition-colors duration-200 hover:text-[#FF5500]"
              >
                <Instagram className="h-4 w-4" />
                @lapinza.app
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="pointer-events-none select-none px-2">
        <h2 className="font-heading text-[18vw] font-black leading-[0.8] tracking-tighter text-white/[0.04]">
          LA PINZA
        </h2>
      </div>

      <div className="border-t border-white/10 py-6">
        <p className="mx-auto max-w-7xl px-5 font-ui text-[11px] uppercase tracking-[0.2em] text-[#64748B] md:px-8">
          © {new Date().getFullYear()} La Pinza · Battle Arena
        </p>
      </div>
    </footer>
  );
}
